import { memo } from "react";

interface iProps {
  isToggle: boolean;
  ViewToggle: React.ReactNode;
  ViewDefault: React.ReactNode;
}

const ComponentToggle = ({ isToggle, ViewToggle, ViewDefault }: iProps) => {
  if (isToggle) {
    return <>{ViewToggle}</>;
  }

  return <>{ViewDefault}</>;
};

export default memo(ComponentToggle);
